import styled from "styled-components";
import { colors } from "./colors";
import { motion } from "framer-motion";

export const SidebarContainer = styled.aside`
  width: 250px;
  background-color: ${colors.surface};
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  transition: transform 0.3s ease-in-out;
  transform: ${({ isOpen }) => (isOpen ? "translateX(0)" : "translateX(-100%)")};
  padding: 20px 0;
  display: flex;
  flex-direction: column;

  @media (min-width: 769px) {
    transform: translateX(0);
  }
`;

export const SidebarList = styled.ul`
  list-style: none;
  padding: 0 20px; /* Padding to align buttons with some margin */
  margin: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const SidebarItem = styled(motion.li)`
  display: flex;
  justify-content: flex-start; /* Align buttons to the left */
`;

export const SidebarButton = styled(motion.button)`
  display: inline-flex;
  align-items: center;
  gap: 30px;
  padding: 10px 15px;
  background-color: ${colors.gradientEnd};
  color: ${colors.textDark};
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${colors.gold};
    color: ${colors.darkBane};
  }
`;

export const CountBadge = styled.span`
  background-color: ${colors.accent};
  color: ${colors.surface};
  border-radius: 12px;
  padding: 2px 8px;
  font-size: 12px;
  margin-left: 10px;
`;

export const ToggleButton = styled.button`
  position: fixed;
  top: 10px;
  left: 10px;
  z-index: 1000;
  background-color: ${colors.primary};
  color: ${colors.surface};
  border: none;
  padding: 10px;
  border-radius: 5px;
  cursor: pointer;
  display: none;

  @media (max-width: 768px) {
    display: block;
  }
`;